import { Typography } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Button } from '@ovComponents/2-component/button/button';
import {
  Dialog,
  DialogContent,
  DialogTitle,
} from '@ovComponents/2-component/dialog/dialog';
import { useTranslation } from 'react-i18next';

type ImportCsvPromptDialogProps = {
  open: boolean;
  onClose: () => void;
  onImport: () => void;
};

export const ImportCsvPromptDialog = ({
  open,
  onClose,
  onImport,
}: ImportCsvPromptDialogProps) => {
  const { t } = useTranslation(['modelPortfolios', 'shared']);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='sm'
      fullWidth
      data-testid='import-csv-prompt-dialog'
    >
      <DialogTitle onClose={onClose}>
        {t('modelPortfolios:importCsv.title')}
      </DialogTitle>
      <DialogContent>
        <Typography
          variant='body1'
          color='text.secondary'
          sx={{ fontSize: '16px' }}
        >
          {t('modelPortfolios:importCsv.description')}
        </Typography>
        <Box display='flex' justifyContent='end' gap={1} mt={3}>
          <Button
            onClick={onClose}
            variant='tonal'
            label={t('shared:later')}
            dataTestId='import-csv-prompt-later-button'
          />
          <Button
            onClick={() => {
              onClose();
              onImport();
            }}
            variant='filled'
            label={t('modelPortfolios:importCsv.import')}
            color='primary'
            dataTestId='import-csv-prompt-import-button'
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ImportCsvPromptDialog;
